<div class="text-right">
  @if (closed) {
    <button class="panelShifter" (click)="openPanel()" aria-label="maximize the panel's width">
      <span class="material-icons">last_page</span>
    </button>
  }
</div>
@if (!closed) {
  <div class="teamMembers"
    [ngClass]="{assessment: applicationType === appType.assessment, accreditation: applicationType === appType.accreditation}"
    >
    <div *blockUI="'bulkUsersUI'; template:blockTemplate">
      <div class="sectionDivider">
        <h3 class="pageHeader">Team ({{everyUser.length}})</h3>
        <div class="text-right">
          @if (!closed) {
            <button class="panelShifter" (click)="minimizePanel()" aria-label="minimize the panel's width">
              <span class="material-icons">first_page</span>
            </button>
          }
        </div>
      </div>
      <hr class="fullWidthHr">
      <app-member-add
        [applicationType]="applicationType"
        [projectLocked]="projectLocked"
        [allUsers]="allUsers"
        [allTeamUsers]="everyUser"
        [editMembers]="editMembers"
        [commentMembers]="commentMembers"
        [readMembers]="readMembers"
        [adminMembers]="adminMembers"
        [evalMembers]="evalMembers"
        [editGroups]="editGroups"
        [commentGroups]="commentGroups"
        [readGroups]="readGroups"
        [allAvailableGroups]="allGroups"
        (addSignal)="addIndividual($event)"
        (addGroupSignal)="addGroup($event)"
      ></app-member-add>
      <hr class="fullWidthHr">
      @if (allUsers && !reloading) {
        <app-member-search
          [applicationType]="applicationType"
          [allUsers]="allUsers"
          [allAvailableGroups]="allGroups"
          [allTeamUsers]="everyUser"
          [editMembers]="editMembers"
          [commentMembers]="commentMembers"
          [readMembers]="readMembers"
          [adminMembers]="adminMembers"
          [evalMembers]="evalMembers"
          [editGroups]="editGroups"
          [commentGroups]="commentGroups"
          [readGroups]="readGroups"
          [isGroupSearch]="true"
          [isUserSearch]="true"
          [projectLocked]="projectLocked"
          (addSignal)="addIndividual($event)"
          (addGroupSignal)="addGroup($event)"
        ></app-member-search>
      }
      <button
        [ngClass]="{addMember: true, smallTitle: true, opened: viewByExpanded, viewByBtn: true, specialLabelNav: true}"
        (click)="viewByExpanded = !viewByExpanded"
        id="viewByBtn"
        >VIEW BY: {{viewBy}}
        @if (viewByExpanded) {
          <i class="viewByBtn material-icons">arrow_drop_up</i>
        }
        @if (!viewByExpanded) {
          <i class="viewByBtn material-icons">arrow_drop_down</i>
        }
      </button>
      @if (viewByExpanded) {
        <div class="filterMembersPane">
          <button class="addMember opened addMemberButton specialLabelNav" (click)="showAll()">ALL</button>
          <button class="addMember opened addMemberButton specialLabelNav" (click)="showReadOnly()">READ ONLY</button>
          @if (applicationType === appType.accreditation) {
            <button class="addMember opened addMemberButton specialLabelNav" (click)="showCommentOnly()">COMMENT ONLY</button>
          }
          <button class="addMember opened addMemberButton specialLabelNav" (click)="showEditOnly()">EDIT ONLY</button>
          <button class="addMember opened addMemberButton specialLabelNav" (click)="showIndividualsOnly()">INDIVIDUAL USERS</button>
          <button class="addMember opened addMemberButton specialLabelNav" (click)="showGroupsOnly()">GROUPS</button>
          @if (applicationType === appType.accreditation) {
            <button class="addMember opened addMemberButton specialLabelNav" (click)="showEvaluatorsOnly()">EVALUATORS</button>
          }
          <button class="addMember opened addMemberButton specialLabelNav" (click)="showAdminsOnly()">ADMINISTRATORS</button>
        </div>
      }
      @if (editCount && editFilter) {
        <div class="members">
          <hr>
            <h3 class="specialLabelNav">
              <i class="accessIcon material-icons">edit</i> EDIT ACCESS ({{editCount}})
              <button class="rightIcon" (click)="editExpanded = !editExpanded">
                @if (editExpanded) {
                  <i class="material-icons">expand_less</i>
                }
                @if (!editExpanded) {
                  <i class="material-icons">expand_more</i>
                }
              </button>
            </h3>
            @if (editExpanded) {
              <ul>
                @for (member of editMembers; track member) {
                  <li>
                    @if (individualsFilter) {
                      <app-member
                        [member]="member"
                        [applicationType]="applicationType"
                        [projectLocked]="projectLocked"
                        (changeValue)="changeUserAccess($event)"
                        (deleteSignal)="removeUserWarning($event)"
                      ></app-member>
                    }
                  </li>
                }
                @for (group of editGroups; track group) {
                  <li>
                    @if (groupsFilter) {
                      <app-member-group
                        [group]="group"
                        [projectLocked]="projectLocked"
                        [applicationType]="applicationType"
                        (deleteSignal)="removeGroupWarning($event)"
                      ></app-member-group>
                    }
                  </li>
                }
              </ul>
            }
          </div>
        }
        @if (readCount && readFilter) {
          <div class="members">
            <hr>
              <h3 class="specialLabelNav">
                <i class="accessIcon material-icons">visibility</i> READ ACCESS ({{readCount}})
                <button class="rightIcon" (click)="readExpanded = !readExpanded">
                  @if (readExpanded) {
                    <i class="material-icons">expand_less</i>
                  }
                  @if (!readExpanded) {
                    <i class="material-icons">expand_more</i>
                  }
                </button>
              </h3>
              @if (readExpanded) {
                <ul>
                  @for (member of readMembers; track member) {
                    <li>
                      @if (individualsFilter) {
                        <app-member
                          [applicationType]="applicationType"
                          [member]="member" [projectLocked]="projectLocked"
                          (changeValue)="changeUserAccess($event)"
                          (deleteSignal)="removeUserWarning($event)"
                        ></app-member>
                      }
                    </li>
                  }
                  @for (group of readGroups; track group) {
                    <li>
                      @if (groupsFilter) {
                        <app-member-group
                          [group]="group"
                          [projectLocked]="projectLocked"
                          [applicationType]="applicationType"
                          (deleteSignal)="removeGroupWarning($event)"
                        ></app-member-group>
                      }
                    </li>
                  }
                </ul>
              }
            </div>
          }
          @if (commentCount && commentFilter) {
            <div class="members">
              <hr>
                <h3 class="specialLabelNav">
                  <i class="accessIcon material-icons">comment</i> COMMENT ACCESS ({{commentCount}})
                  <button class="rightIcon" (click)="commentExpanded = !commentExpanded">
                    @if (commentExpanded) {
                      <i class="material-icons">expand_less</i>
                    }
                    @if (!commentExpanded) {
                      <i class="material-icons">expand_more</i>
                    }
                  </button>
                </h3>
                @if (commentExpanded) {
                  <ul>
                    @for (member of commentMembers; track member) {
                      <li>
                        @if (individualsFilter) {
                          <app-member
                            [applicationType]="applicationType"
                            [member]="member"
                            [projectLocked]="projectLocked"
                            (changeValue)="changeUserAccess($event)"
                            (deleteSignal)="removeUserWarning($event)"
                          ></app-member>
                        }
                      </li>
                    }
                    @for (group of commentGroups; track group) {
                      <li>
                        @if (groupsFilter) {
                          <app-member-group
                            [group]="group"
                            [projectLocked]="projectLocked"
                            [applicationType]="applicationType"
                            (deleteSignal)="removeGroupWarning($event)"
                          ></app-member-group>
                        }
                      </li>
                    }
                  </ul>
                }
              </div>
            }
            @if (evalCount && evalFilter) {
              <div class="members">
                <hr>
                  <h3 class="specialLabelNav">REVIEWERS ({{evalCount}})
                    <button class="rightIcon" (click)="evaluatorsExpanded = !evaluatorsExpanded">
                      @if (evaluatorsExpanded) {
                        <i class="material-icons">expand_less</i>
                      }
                      @if (!evaluatorsExpanded) {
                        <i class="material-icons">expand_more</i>
                      }
                    </button>
                  </h3>
                  @if (evaluatorsExpanded) {
                    <ul>
                      @for (member of evalMembers; track member) {
                        <li>
                          <app-member [applicationType]="applicationType" [member]="member" [hideFunctions]="true"></app-member>
                        </li>
                      }
                    </ul>
                  }
                </div>
              }
              @if (adminCount && adminFilter) {
                <div class="members">
                  <hr>
                    <h3 class="specialLabelNav">ADMINISTRATORS ({{adminCount}})
                      <button class="rightIcon" (click)="adminsExpanded = !adminsExpanded">
                        @if (adminsExpanded) {
                          <i class="material-icons">expand_less</i>
                        }
                        @if (!adminsExpanded) {
                          <i class="material-icons">expand_more</i>
                        }
                      </button>
                    </h3>
                    @if (adminsExpanded) {
                      <ul>
                        @for (member of adminMembers; track member) {
                          <li>
                            <app-member [applicationType]="applicationType" [member]="member" [hideFunctions]="true"></app-member>
                          </li>
                        }
                      </ul>
                    }
                  </div>
                }
              </div>
            </div>
          }
